import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-login',
  template: ``,
})
export class PortalLoginComponent implements OnInit {
  constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {}
  ngOnInit() {
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      if (isAuthenticated) {
        this.router.navigate(['/portal']);
      } else {
        this.oidcSecurityService.authorize();
      }
    });
  }
}
